import { createElement } from '../../adapters/dom';

const STATUS_LABELS: Record<string, string> = {
  created: 'Создан',
  method_selected: 'Метод выбран',
  address_assigned: 'Адрес выдан',
  awaiting_payment: 'Ожидаем оплату',
  payment_detected: 'Платёж найден',
  confirming: 'Подтверждается',
  success: 'Успешно',
  partial_payment: 'Недоплата',
  overpayment: 'Переплата',
  expired: 'Истекло время',
  cancelled: 'Отменено',
  failed: 'Ошибка',
  loading: 'Загрузка',
  network_error: 'Ошибка сети'
};

export function getStatusLabel(status: string): string {
  return STATUS_LABELS[status] ?? status;
}

export function createStatusBadge(status: string): HTMLSpanElement {
  return createElement('span', {
    className: `cpw-status-badge cpw-status-${status}`,
    textContent: getStatusLabel(status)
  }) as HTMLSpanElement;
}